import Logo from "components/Logo/Logo";
import styled from "styled-components";

// Shared filter components — single source of truth
export {
  Filter,
  FilterTooltipBody,
  InnerTitle,
  Overlay,
  ResetFilter,
  ResetIcon,
  SearchTooltip,
  SubmitWrapper,
  TooltipContent,
} from "components/Filters/Filters.styles";

export const FilterLogo = styled(Logo)`
  margin-right: 10px;
`;
